[
  {
    "id": 0,
    "duration": "1000",
    "vertical": [
      {
        "startPosition": 3.1,
        "drawToPosition": 0,
        "drawFull": true,
        "name": "PrimaryLeft",
        "drawFromPosition": 100
      },
      {
        "startPosition": 26,
        "drawFull": true,
        "name": "Left1",
        "drawFromPosition": 0,
        "drawToPosition": 50
      },
      {
        "drawFull": true,
        "name": "Equator",
        "drawToPosition": 50,
        "drawFromPosition": 0,
        "startPosition": 50
      },
      {
        "startPosition": 74,
        "drawToPosition": 50,
        "name": "Right1",
        "drawFromPosition": 0,
        "drawFull": true
      },
      {
        "drawFromPosition": 100,
        "drawToPosition": 0,
        "name": "PrimaryRight",
        "startPosition": 96.9,
        "drawFull": true
      },
      {
        "drawFromPosition": 50,
        "drawToPosition": 100,
        "drawFull": true,
        "name": "EquatorBottom",
        "startPosition": 50
      },
      {
        "startPosition": 26,
        "name": "Left1Bottom",
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "drawFull": true
      },
      {
        "name": "RightBottom",
        "drawFromPosition": 50,
        "drawToPosition": 100,
        "drawFull": true,
        "startPosition": 74
      }
    ],
    "delayHorizontal": true,
    "circle": [],
    "delayVertical": true,
    "name": "ChapterSetup",
    "horizontal": [
      {
        "drawFromPosition": 0,
        "name": "PrimaryTop",
        "startPosition": 5.6,
        "drawToPosition": 100,
        "drawFull": true
      },
      {
        "drawFull": true,
        "drawToPosition": 50,
        "startPosition": 50,
        "drawFromPosition": 0,
        "name": "Equator",
        "delay": 100
      },
      {
        "startPosition": 94.4,
        "drawToPosition": 100,
        "name": "PrimaryBottom",
        "drawFromPosition": 0,
        "drawFull": true,
        "delay": 200
      },
      {
        "name": "EquatorRight",
        "drawFull": true,
        "drawToPosition": 100,
        "startPosition": 50,
        "drawFromPosition": 50,
        "delay": 100
      }
    ],
    "drawBorder": true,
    "verticalDelayDirection": -1,
    "mask": []
  },
  {
    "name": "ChapterEntry",
    "id": 1,
    "delayHorizontal": true,
    "drawBorder": true,
    "vertical": [
      {
        "startPosition": 3.1,
        "endPosition": -1,
        "drawToPosition": 0,
        "drawFromPosition": 100,
        "drawFull": true,
        "name": "PrimaryLeft"
      },
      {
        "name": "Left1",
        "endPosition": -1,
        "drawToPosition": 50,
        "startPosition": 26,
        "drawFull": true,
        "drawFromPosition": 0
      },
      {
        "name": "Equator",
        "drawFromPosition": 0,
        "drawToPosition": 50,
        "startPosition": 50,
        "drawFull": true
      },
      {
        "endPosition": 87.5,
        "drawFull": true,
        "drawToPosition": 50,
        "name": "Right1",
        "drawFromPosition": 0,
        "startPosition": 74
      },
      {
        "drawFromPosition": 100,
        "name": "PrimaryRight",
        "endPosition": 101,
        "drawToPosition": 0,
        "startPosition": 96.9,
        "drawFull": true
      },
      {
        "drawFull": true,
        "startPosition": 50,
        "drawFromPosition": 50,
        "name": "EquatorBottom",
        "drawToPosition": 100
      },
      {
        "drawFromPosition": 50,
        "startPosition": 26,
        "drawToPosition": 100,
        "endPosition": -1,
        "drawFull": true,
        "name": "Left1Bottom"
      },
      {
        "drawFromPosition": 50,
        "drawFull": true,
        "name": "RightBottom",
        "startPosition": 74,
        "drawToPosition": 100
      }
    ],
    "mask": [
      {
        "vertical": [
          "Equator",
          "Right1"
        ],
        "asset": 0,
        "polyOnly": true,
        "name": "Headline",
        "grid": 0,
        "horizontal": [
          "PrimaryTop",
          "RightTopAux"
        ]
      },
      {
        "name": "Description",
        "horizontal": [
          "RightTopAux",
          "EquatorRight"
        ],
        "vertical": [
          "Equator",
          "Right1"
        ],
        "polyOnly": true,
        "grid": 0,
        "asset": 0
      }
    ],
    "circle": [],
    "horizontal": [
      {
        "name": "PrimaryTop",
        "drawFull": true,
        "startPosition": 5.6,
        "drawFromPosition": 0,
        "drawToPosition": 100
      },
      {
        "endPosition": 94.4,
        "drawDirection": 1,
        "drawFromPosition": 0,
        "drawFull": true,
        "drawToPosition": 50,
        "name": "Equator",
        "startPosition": 50
      },
      {
        "startPosition": 94.4,
        "drawFull": true,
        "drawToPosition": 100,
        "delay": 200,
        "drawFromPosition": 0,
        "name": "PrimaryBottom"
      },
      {
        "delay": 100,
        "drawFull": true,
        "name": "EquatorRight",
        "drawFromPosition": 50,
        "startPosition": 50,
        "drawToPosition": 100
      },
      {
        "endPosition": 27.5,
        "delay": 100,
        "drawFull": true,
        "name": "RightTopAux",
        "drawFromPosition": 50,
        "drawToPosition": 100,
        "startPosition": 50
      }
    ],
    "delayVertical": false,
    "duration": "1000"
  },
  {
    "delayHorizontal": true,
    "vertical": [
      {
        "startPosition": -1,
        "name": "PrimaryLeft",
        "drawToPosition": 0,
        "drawFull": true,
        "endPosition": -1,
        "drawFromPosition": 100
      },
      {
        "drawFull": true,
        "endPosition": -1,
        "drawToPosition": 50,
        "startPosition": -1,
        "name": "Left1",
        "drawFromPosition": 0
      },
      {
        "name": "Equator",
        "drawFull": true,
        "drawFromPosition": 0,
        "drawToPosition": 50,
        "endPosition": 50,
        "startPosition": 50
      },
      {
        "drawFull": true,
        "startPosition": 87.5,
        "name": "Right1",
        "endPosition": 87.5,
        "drawFromPosition": 0,
        "drawToPosition": 50
      },
      {
        "drawFromPosition": 100,
        "drawToPosition": 0,
        "drawFull": true,
        "endPosition": 101,
        "name": "PrimaryRight",
        "startPosition": 101
      },
      {
        "drawFull": true,
        "name": "EquatorBottom",
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "endPosition": 50,
        "startPosition": 50
      },
      {
        "drawFull": true,
        "name": "Left1Bottom",
        "drawToPosition": 100,
        "startPosition": -1,
        "endPosition": -1,
        "drawFromPosition": 50
      },
      {
        "drawToPosition": 100,
        "endPosition": 74,
        "drawFromPosition": 50,
        "name": "RightBottom",
        "drawFull": true,
        "startPosition": 74
      },
      {
        "startAlpha": 0.01,
        "name": "HeroMaskLine",
        "drawToLine": "PrimaryBottom",
        "startPosition": 0,
        "drawFromLine": "PrimaryTop",
        "endPosition": 50,
        "drawFull": true
      },
      {
        "name": "Grid1MaskLine",
        "drawToPosition": 100,
        "drawFromPosition": 0,
        "startAlpha": 0.01,
        "startPosition": 87.5,
        "endPosition": 100,
        "drawFull": true
      },
      {
        "drawFromPosition": 0,
        "startPosition": 74,
        "drawFull": true,
        "drawToPosition": 100,
        "endPosition": 100,
        "startAlpha": 0.01,
        "delay": 500,
        "name": "Grid2MaskLine"
      }
    ],
    "id": 1,
    "mask": [
      {
        "name": "Headline",
        "asset": 0,
        "horizontal": [
          "PrimaryTop",
          "RightTopAux"
        ],
        "vertical": [
          "Equator",
          "Right1"
        ],
        "polyOnly": true,
        "grid": 0
      },
      {
        "grid": 0,
        "vertical": [
          "Equator",
          "Right1"
        ],
        "horizontal": [
          "RightTopAux",
          "EquatorRight"
        ],
        "asset": 0,
        "name": "Description",
        "polyOnly": true
      },
      {
        "horizontal": [
          "PrimaryTop",
          "PrimaryBottom"
        ],
        "grid": 0,
        "vertical": [
          "Left Border",
          "HeroMaskLine"
        ],
        "coverFill": true,
        "container": "mask",
        "asset": 0,
        "name": "HeroMask"
      },
      {
        "name": "Grid1",
        "grid": 0,
        "horizontal": [
          "PrimaryTop",
          "RightTopAux"
        ],
        "asset": 1,
        "coverFill": true,
        "container": "mask",
        "vertical": [
          "Right1",
          "Grid1MaskLine"
        ]
      },
      {
        "name": "Grid2",
        "horizontal": [
          "EquatorRight",
          "PrimaryBottom"
        ],
        "asset": 2,
        "container": "mask",
        "vertical": [
          "RightBottom",
          "Grid2MaskLine"
        ],
        "coverFill": true,
        "grid": 0
      }
    ],
    "horizontal": [
      {
        "drawFull": true,
        "endPosition": 5.6,
        "name": "PrimaryTop",
        "drawFromPosition": 0,
        "startPosition": 5.6,
        "drawToPosition": 100
      },
      {
        "startPosition": 94.4,
        "name": "Equator",
        "drawDirection": 1,
        "drawFromPosition": 0,
        "endPosition": 94.4,
        "drawToPosition": 50,
        "drawFull": true
      },
      {
        "name": "PrimaryBottom",
        "endPosition": 94.4,
        "delay": 200,
        "drawFull": true,
        "drawFromPosition": 0,
        "startPosition": 94.4,
        "drawToPosition": 100
      },
      {
        "drawToPosition": 100,
        "endPosition": 50,
        "drawFromPosition": 50,
        "startPosition": 50,
        "name": "EquatorRight",
        "drawFull": true,
        "delay": 100
      },
      {
        "endPosition": 27.5,
        "delay": 100,
        "startPosition": 27.5,
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "drawFull": true,
        "name": "RightTopAux"
      }
    ],
    "drawBorder": true,
    "delayVertical": false,
    "name": "ChapterEntry",
    "circle": [],
    "duration": "1000"
  },
  {
    "circle": [],
    "vertical": [
      {
        "drawFull": true,
        "drawToPosition": 0,
        "endPosition": -1,
        "drawFromPosition": 100,
        "name": "PrimaryLeft",
        "startPosition": -1
      },
      {
        "drawFull": true,
        "endPosition": -1,
        "startPosition": -1,
        "drawFromPosition": 0,
        "drawToPosition": 50,
        "name": "Left1"
      },
      {
        "drawFromPosition": 0,
        "drawToPosition": 50,
        "endPosition": 50,
        "startPosition": 50,
        "drawFull": true,
        "name": "Equator"
      },
      {
        "drawFull": true,
        "endPosition": 87.5,
        "name": "Right1",
        "drawToPosition": 50,
        "drawFromPosition": 0,
        "startPosition": 87.5
      },
      {
        "drawFull": true,
        "startPosition": 101,
        "endPosition": 101,
        "drawFromPosition": 100,
        "name": "PrimaryRight",
        "drawToPosition": 0
      },
      {
        "drawToPosition": 100,
        "drawFull": true,
        "startPosition": 50,
        "name": "EquatorBottom",
        "drawFromPosition": 50,
        "endPosition": 50
      },
      {
        "drawToPosition": 100,
        "endPosition": -1,
        "drawFromPosition": 50,
        "name": "Left1Bottom",
        "drawFull": true,
        "startPosition": -1
      },
      {
        "drawFromPosition": 50,
        "endPosition": 74,
        "drawToPosition": 100,
        "name": "RightBottom",
        "startPosition": 74,
        "drawFull": true
      },
      {
        "startPosition": 50,
        "delay": 2000,
        "drawToLine": "PrimaryBottom",
        "startAlpha": 0.01,
        "name": "HeroMaskLine",
        "drawFull": true,
        "endPosition": 0,
        "drawFromLine": "PrimaryTop"
      },
      {
        "drawToPosition": 100,
        "drawFromPosition": 0,
        "endPosition": 87.5,
        "startPosition": 100,
        "delay": 2500,
        "startAlpha": 0.01,
        "name": "Grid1MaskLine",
        "drawFull": true
      },
      {
        "drawToPosition": 100,
        "startPosition": 100,
        "drawFromPosition": 0,
        "startAlpha": 0.01,
        "drawFull": true,
        "delay": 1500,
        "name": "Grid2MaskLine",
        "endPosition": 74
      }
    ],
    "name": "ChapterEntry",
    "delayVertical": false,
    "delayHorizontal": true,
    "id": 1,
    "horizontal": [
      {
        "drawToPosition": 100,
        "endPosition": 5.6,
        "drawFull": true,
        "drawFromPosition": 0,
        "startPosition": 5.6,
        "name": "PrimaryTop"
      },
      {
        "drawFull": true,
        "name": "Equator",
        "endPosition": 94.4,
        "drawToPosition": 50,
        "drawDirection": 1,
        "startPosition": 94.4,
        "drawFromPosition": 0
      },
      {
        "name": "PrimaryBottom",
        "drawToPosition": 100,
        "endPosition": 94.4,
        "drawFromPosition": 0,
        "startPosition": 94.4,
        "drawFull": true,
        "delay": 200
      },
      {
        "drawFull": true,
        "name": "EquatorRight",
        "delay": 100,
        "endPosition": 50,
        "drawFromPosition": 50,
        "startPosition": 50,
        "drawToPosition": 100
      },
      {
        "drawFull": true,
        "startPosition": 27.5,
        "name": "RightTopAux",
        "delay": 100,
        "endPosition": 27.5,
        "drawFromPosition": 50,
        "drawToPosition": 100
      }
    ],
    "mask": [
      {
        "grid": 0,
        "name": "Headline",
        "vertical": [
          "Equator",
          "Right1"
        ],
        "polyOnly": true,
        "horizontal": [
          "PrimaryTop",
          "RightTopAux"
        ],
        "asset": 0
      },
      {
        "name": "Description",
        "horizontal": [
          "RightTopAux",
          "EquatorRight"
        ],
        "grid": 0,
        "polyOnly": true,
        "vertical": [
          "Equator",
          "Right1"
        ],
        "asset": 0
      },
      {
        "grid": 0,
        "vertical": [
          "Left Border",
          "HeroMaskLine"
        ],
        "container": "mask",
        "asset": 0,
        "coverFill": true,
        "name": "HeroMask",
        "horizontal": [
          "PrimaryTop",
          "PrimaryBottom"
        ]
      },
      {
        "horizontal": [
          "PrimaryTop",
          "RightTopAux"
        ],
        "name": "Grid1",
        "vertical": [
          "Right1",
          "Grid1MaskLine"
        ],
        "container": "mask",
        "asset": 1,
        "coverFill": true,
        "grid": 0
      },
      {
        "asset": 2,
        "grid": 0,
        "name": "Grid2",
        "container": "mask",
        "coverFill": true,
        "vertical": [
          "RightBottom",
          "Grid2MaskLine"
        ],
        "horizontal": [
          "EquatorRight",
          "PrimaryBottom"
        ]
      }
    ],
    "drawBorder": true,
    "duration": "1000"
  },
  {
    "id": 2,
    "circle": [],
    "name": "ChapterExit",
    "vertical": [
      {
        "startPosition": -1,
        "drawFull": true,
        "endPosition": 3.1,
        "drawToPosition": 0,
        "drawFromPosition": 100,
        "name": "PrimaryLeft"
      },
      {
        "drawToPosition": 50,
        "endPosition": 26,
        "startPosition": -1,
        "name": "Left1",
        "drawFull": true,
        "drawFromPosition": 0
      },
      {
        "drawFromPosition": 0,
        "drawFull": true,
        "drawToPosition": 50,
        "name": "Equator",
        "startPosition": 50
      },
      {
        "startPosition": 87.5,
        "endPosition": 74,
        "drawFromPosition": 0,
        "name": "Right1",
        "drawFull": true,
        "drawToPosition": 50
      },
      {
        "startPosition": 101,
        "endPosition": 96.9,
        "drawToPosition": 0,
        "drawFromPosition": 100,
        "drawFull": true,
        "name": "PrimaryRight"
      },
      {
        "name": "EquatorBottom",
        "startPosition": 50,
        "drawToPosition": 100,
        "drawFromPosition": 50,
        "drawFull": true
      },
      {
        "name": "Left1Bottom",
        "drawFromPosition": 50,
        "startPosition": -1,
        "drawFull": true,
        "drawToPosition": 100,
        "endPosition": 26
      },
      {
        "drawFromPosition": 50,
        "drawToPosition": 100,
        "name": "RightBottom",
        "startPosition": 74,
        "drawFull": true
      }
    ],
    "drawBorder": true,
    "delayVertical": false,
    "horizontal": [
      {
        "drawFull": true,
        "name": "PrimaryTop",
        "drawFromPosition": 0,
        "startPosition": 5.6,
        "drawToPosition": 100
      },
      {
        "drawToPosition": 50,
        "drawDirection": 1,
        "drawFromPosition": 0,
        "drawFull": true,
        "name": "Equator",
        "startPosition": 94.4,
        "endPosition": 50
      },
      {
        "drawFromPosition": 0,
        "name": "PrimaryBottom",
        "startPosition": 94.4,
        "drawFull": true,
        "drawToPosition": 100,
        "delay": 200
      },
      {
        "drawToPosition": 100,
        "delay": 100,
        "name": "EquatorRight",
        "drawFull": true,
        "startPosition": 50,
        "drawFromPosition": 50
      },
      {
        "drawFromPosition": 50,
        "name": "RightTopAux",
        "drawToPosition": 100,
        "endPosition": 50,
        "removeAtEndPosition": true,
        "delay": 0,
        "drawFull": true,
        "startPosition": 27.5
      }
    ],
    "delayHorizontal": true,
    "duration": "1000",
    "mask": []
  }
]